/**
 * 전역 border-radius 토큰 — 버튼·모달·카드·태그 등에서 동일한 곡률을 쓰기 위함
 */
export const borderRadius = {
	none: '0',
	/** 토스트·작은 CTA 등 (약 4px @ 16px root) */
	xs: '0.25rem',
	/** 모달 패널·보조 버튼·페이지네이션 끝단 */
	sm: '0.4rem',
	/**
	 * 폼 컨트롤 공통 — input, textarea, select, 일반 직사각형 button
	 * (원형 FAB·아이콘 버튼·pill 등은 circle / pill로 개별 지정)
	 */
	control: '0.4rem',
	/** 카드·강조 박스 (약 8px) */
	md: '0.5rem',
	lg: '1.2rem',
	xl: '1.6rem',
	xxl: '2.4rem',
	/** 모바일 메뉴 패널 등 큰 라운드 */
	panel: '3rem',
	/** 캡슐형 (MY, 뱃지) */
	pill: '9999px',
	/** 정사각형 기준 원형 (탑 버튼·라디오 등) */
	circle: '50%',
} as const;

export type BorderRadiusTypes = typeof borderRadius;
